import { useReactiveVar } from '@apollo/client';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import type React from 'react';
import { useEffect } from 'react';
import styles from 'src/HomePage/DrawerAndPushedContents/PushedContents/TopPaginationNavBar/SelectAllCheckbox/SelectAllCheckboxStyles';
import viewStateVar from 'src/store/viewState';

const SelectAllCheckbox: React.FC = () => {
  const classes = styles();
  const { isSelectAll } = useReactiveVar(viewStateVar);

  useEffect(() => {
    viewStateVar({
      ...viewStateVar(),
      selectedAssets: [],
      isSelectAll: false,
    });
  }, []);

  const toggleSelectAllState = (): void => {
    if (isSelectAll) {
      viewStateVar({
        ...viewStateVar(),
        selectedAssets: [],
      });
    }

    viewStateVar({
      ...viewStateVar(),
      isSelectAll: !isSelectAll,
    });
  };

  return (
    <FormControlLabel
      classes={{ root: classes.selectAll }}
      onChange={toggleSelectAllState}
      label={
        <Box
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: '14px',
          }}
        >
          Select All
        </Box>
      }
      name="remember"
      control={<Checkbox checked={isSelectAll} />}
    />
  );
};

export default SelectAllCheckbox;
